import { AuthRepository } from './repository'
import { RegisteredUserInfo, UserAuthToken } from '~/models/AuthToken'

export class AuthService {
	static async loginWithPassword(email: string, password: string): Promise<UserAuthToken> {
		return await AuthRepository.login(email, password)
	}

	static async register(
		email: string,
		password: string,
		registerUrl?: string
	): Promise<RegisteredUserInfo> {
		return await AuthRepository.register(email, password, registerUrl)
	}

	static async logout(): Promise<void> {
		return await AuthRepository.logout()
	}

	static async loginWithToken(token: string): Promise<UserAuthToken> {
		return await AuthRepository.login(undefined, undefined, token)
	}

	static async requestPasswordlessLogin(email: string, registerUrl?: string): Promise<void> {
		return await AuthRepository.requestPasswordlessLogin(email, registerUrl)
	}

	static async loginWithGoogle(googleToken: string, registerUrl?: string): Promise<UserAuthToken> {
		return await AuthRepository.loginOAuth('google', googleToken, registerUrl)
	}

	static async requestPasswordReset(email: string) {
		return await AuthRepository.requestPasswordReset(email)
	}

	static async restorePassword(code: string, email: string, password: string): Promise<void> {
		return await AuthRepository.restorePassword(code, email, password)
	}
}
